/**
 * Global feature flags and toggles.
 * These are configuration values that affect application behavior globally.
 */

import { getRuntimeConfig } from "~/common/config/runtimeConfig";

export function isMarketingConsentEnabled() {
  return getRuntimeConfig().marketingConsentEnabled;
}

export function isLineLevelCustomerOrderNumberEnabled() {
  return getRuntimeConfig().lineLevelCustomerOrderNumberEnabled;
}

export function isTruncateDesignationsEnabled() {
  return true;
}

export function isCADInquiryEnabled() {
  return false;
}

export function isMultiAccountOrderSearchEnabled() {
  return getRuntimeConfig().multipleAccountSearchEnabled;
}

export function isPartialDeliveriesEnabled() {
  return true;
}

export function showDateAsCalendarWeek() {
  return getRuntimeConfig().showDateAsCalendarWeek;
}

export function isPhaseOut2Enabled() {
  return getRuntimeConfig().phaseOutEnabled;
}
